var cov_1bxgdyusb8 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tooltip/events.tsx",
      hash = "dceb209af2245ecaad928e5c7a7c18a92927bd3b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tooltip/events.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 33
        },
        end: {
          line: 8,
          column: 37
        }
      },
      "1": {
        start: {
          line: 10,
          column: 35
        },
        end: {
          line: 10,
          column: 39
        }
      },
      "2": {
        start: {
          line: 11,
          column: 35
        },
        end: {
          line: 11,
          column: 39
        }
      },
      "3": {
        start: {
          line: 14,
          column: 19
        },
        end: {
          line: 14,
          column: 102
        }
      },
      "4": {
        start: {
          line: 14,
          column: 53
        },
        end: {
          line: 14,
          column: 101
        }
      },
      "5": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 32
        }
      },
      "6": {
        start: {
          line: 17,
          column: 13
        },
        end: {
          line: 17,
          column: 32
        }
      },
      "7": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "8": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 30
        }
      },
      "9": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 22
        }
      },
      "10": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 23
        }
      },
      "11": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 26,
          column: 8
        }
      },
      "12": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 50
        }
      },
      "13": {
        start: {
          line: 30,
          column: 46
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "14": {
        start: {
          line: 31,
          column: 75
        },
        end: {
          line: 31,
          column: 80
        }
      },
      "15": {
        start: {
          line: 33,
          column: 20
        },
        end: {
          line: 33,
          column: 40
        }
      },
      "16": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 39,
          column: 3
        }
      },
      "17": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 14
        }
      },
      "18": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 16
        }
      },
      "19": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 16
        }
      },
      "20": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 45,
          column: 3
        }
      },
      "21": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 39
        }
      },
      "22": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 30
        }
      },
      "23": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 30
        }
      },
      "24": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 51,
          column: 3
        }
      },
      "25": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 41
        }
      },
      "26": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 43
        }
      },
      "27": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 26
        }
      },
      "28": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 57,
          column: 3
        }
      },
      "29": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 41
        }
      },
      "30": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 43
        }
      },
      "31": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 26
        }
      },
      "32": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 59,
          column: 16
        }
      },
      "33": {
        start: {
          line: 61,
          column: 2
        },
        end: {
          line: 61,
          column: 37
        }
      },
      "34": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 64,
          column: 4
        }
      },
      "35": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 47
        }
      },
      "36": {
        start: {
          line: 66,
          column: 20
        },
        end: {
          line: 66,
          column: 79
        }
      },
      "37": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 72,
          column: 7
        }
      },
      "38": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 32
        }
      },
      "39": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 46
        }
      },
      "40": {
        start: {
          line: 74,
          column: 2
        },
        end: {
          line: 74,
          column: 45
        }
      },
      "41": {
        start: {
          line: 76,
          column: 2
        },
        end: {
          line: 76,
          column: 33
        }
      },
      "42": {
        start: {
          line: 77,
          column: 2
        },
        end: {
          line: 81,
          column: 3
        }
      },
      "43": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 80,
          column: 6
        }
      },
      "44": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 79,
          column: 56
        }
      },
      "45": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 85,
          column: 3
        }
      },
      "46": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 49
        }
      },
      "47": {
        start: {
          line: 88,
          column: 46
        },
        end: {
          line: 93,
          column: 1
        }
      },
      "48": {
        start: {
          line: 89,
          column: 2
        },
        end: {
          line: 92,
          column: 3
        }
      },
      "49": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 93
        }
      },
      "50": {
        start: {
          line: 91,
          column: 53
        },
        end: {
          line: 91,
          column: 91
        }
      },
      "51": {
        start: {
          line: 95,
          column: 56
        },
        end: {
          line: 95,
          column: 78
        }
      },
      "52": {
        start: {
          line: 95,
          column: 62
        },
        end: {
          line: 95,
          column: 78
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 19
          },
          end: {
            line: 14,
            column: 20
          }
        },
        loc: {
          start: {
            line: 14,
            column: 53
          },
          end: {
            line: 14,
            column: 101
          }
        },
        line: 14
      },
      "1": {
        name: "hide",
        decl: {
          start: {
            line: 16,
            column: 16
          },
          end: {
            line: 16,
            column: 20
          }
        },
        loc: {
          start: {
            line: 16,
            column: 23
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 16
      },
      "2": {
        name: "clickaway",
        decl: {
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 25,
            column: 18
          }
        },
        loc: {
          start: {
            line: 25,
            column: 21
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 30,
            column: 46
          },
          end: {
            line: 30,
            column: 47
          }
        },
        loc: {
          start: {
            line: 30,
            column: 73
          },
          end: {
            line: 86,
            column: 1
          }
        },
        line: 30
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 62,
            column: 29
          },
          end: {
            line: 62,
            column: 30
          }
        },
        loc: {
          start: {
            line: 62,
            column: 57
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 62
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 69,
            column: 22
          }
        },
        loc: {
          start: {
            line: 69,
            column: 27
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 69
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 78,
            column: 36
          },
          end: {
            line: 78,
            column: 37
          }
        },
        loc: {
          start: {
            line: 78,
            column: 64
          },
          end: {
            line: 80,
            column: 5
          }
        },
        line: 78
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 88,
            column: 46
          },
          end: {
            line: 88,
            column: 47
          }
        },
        loc: {
          start: {
            line: 88,
            column: 59
          },
          end: {
            line: 93,
            column: 1
          }
        },
        line: 88
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 91,
            column: 25
          },
          end: {
            line: 91,
            column: 26
          }
        },
        loc: {
          start: {
            line: 91,
            column: 53
          },
          end: {
            line: 91,
            column: 91
          }
        },
        line: 91
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 95,
            column: 56
          },
          end: {
            line: 95,
            column: 57
          }
        },
        loc: {
          start: {
            line: 95,
            column: 62
          },
          end: {
            line: 95,
            column: 78
          }
        },
        line: 95
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 14,
            column: 20
          },
          end: {
            line: 14,
            column: 47
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 45
          },
          end: {
            line: 14,
            column: 47
          }
        }],
        line: 14
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 53
          },
          end: {
            line: 14,
            column: 101
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 14,
            column: 81
          },
          end: {
            line: 14,
            column: 93
          }
        }, {
          start: {
            line: 14,
            column: 96
          },
          end: {
            line: 14,
            column: 101
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 32
          }
        }, {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 32
          }
        }],
        line: 17
      },
      "3": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }, {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }],
        line: 18
      },
      "4": {
        loc: {
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 31,
            column: 30
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 31,
            column: 28
          },
          end: {
            line: 31,
            column: 30
          }
        }],
        line: 31
      },
      "5": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        }, {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        }],
        line: 35
      },
      "6": {
        loc: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        }, {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        }],
        line: 41
      },
      "7": {
        loc: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        }, {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        }],
        line: 47
      },
      "8": {
        loc: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        }, {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        }],
        line: 53
      },
      "9": {
        loc: {
          start: {
            line: 66,
            column: 54
          },
          end: {
            line: 66,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 54
          },
          end: {
            line: 66,
            column: 63
          }
        }, {
          start: {
            line: 66,
            column: 67
          },
          end: {
            line: 66,
            column: 78
          }
        }],
        line: 66
      },
      "10": {
        loc: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        }, {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        }],
        line: 77
      },
      "11": {
        loc: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 85,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 85,
            column: 3
          }
        }, {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 85,
            column: 3
          }
        }],
        line: 83
      },
      "12": {
        loc: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        }, {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        }],
        line: 89
      },
      "13": {
        loc: {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 22
          }
        }, {
          start: {
            line: 89,
            column: 26
          },
          end: {
            line: 89,
            column: 29
          }
        }],
        line: 89
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import classnames from 'classnames';
import ReactDOM from 'react-dom';
import { tooltipClass } from './styles';
import getCommonContainer from '../utils/dom/popContainer';
var div = (cov_1bxgdyusb8.s[0]++, null);
var timer;
var arrow = (cov_1bxgdyusb8.s[1]++, null);
var inner = (cov_1bxgdyusb8.s[2]++, null);
var currentId;
cov_1bxgdyusb8.s[3]++;

var transStyle = function transStyle() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1bxgdyusb8.b[0][0]++, '');
  cov_1bxgdyusb8.f[0]++;
  cov_1bxgdyusb8.s[4]++;
  return typeof value === 'number' ? (cov_1bxgdyusb8.b[1][0]++, "".concat(value, "px")) : (cov_1bxgdyusb8.b[1][1]++, value);
};

export function hide() {
  cov_1bxgdyusb8.f[1]++;
  cov_1bxgdyusb8.s[5]++;

  if (timer) {
    cov_1bxgdyusb8.b[2][0]++;
    cov_1bxgdyusb8.s[6]++;
    clearTimeout(timer);
  } else {
    cov_1bxgdyusb8.b[2][1]++;
  }

  cov_1bxgdyusb8.s[7]++;

  if (div) {
    cov_1bxgdyusb8.b[3][0]++;
    cov_1bxgdyusb8.s[8]++;
    div.style.display = 'none';
    cov_1bxgdyusb8.s[9]++;
    div.className = '';
  } else {
    cov_1bxgdyusb8.b[3][1]++;
  }

  cov_1bxgdyusb8.s[10]++;
  currentId = undefined;
}

function clickaway() {
  cov_1bxgdyusb8.f[2]++;
  cov_1bxgdyusb8.s[11]++;
  hide();
  cov_1bxgdyusb8.s[12]++;
  document.removeEventListener('click', clickaway);
}

cov_1bxgdyusb8.s[13]++;
export var show = function show(props, id, innerStyle) {
  cov_1bxgdyusb8.f[3]++;

  var _ref = (cov_1bxgdyusb8.s[14]++, props),
      position = _ref.position,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? (cov_1bxgdyusb8.b[4][0]++, {}) : _ref$style,
      tip = _ref.tip,
      trigger = _ref.trigger,
      animation = _ref.animation,
      cn = _ref.className;

  var container = (cov_1bxgdyusb8.s[15]++, getCommonContainer()); // create

  cov_1bxgdyusb8.s[16]++;

  if (!container.contains(div)) {
    cov_1bxgdyusb8.b[5][0]++;
    cov_1bxgdyusb8.s[17]++;
    div = null;
    cov_1bxgdyusb8.s[18]++;
    arrow = null;
    cov_1bxgdyusb8.s[19]++;
    inner = null;
  } else {
    cov_1bxgdyusb8.b[5][1]++;
  }

  cov_1bxgdyusb8.s[20]++;

  if (!div) {
    cov_1bxgdyusb8.b[6][0]++;
    cov_1bxgdyusb8.s[21]++;
    div = document.createElement('div');
    cov_1bxgdyusb8.s[22]++;
    div.style.display = 'none';
    cov_1bxgdyusb8.s[23]++;
    container.appendChild(div);
  } else {
    cov_1bxgdyusb8.b[6][1]++;
  }

  cov_1bxgdyusb8.s[24]++;

  if (!arrow) {
    cov_1bxgdyusb8.b[7][0]++;
    cov_1bxgdyusb8.s[25]++;
    arrow = document.createElement('div');
    cov_1bxgdyusb8.s[26]++;
    arrow.className = tooltipClass('arrow');
    cov_1bxgdyusb8.s[27]++;
    div.appendChild(arrow);
  } else {
    cov_1bxgdyusb8.b[7][1]++;
  }

  cov_1bxgdyusb8.s[28]++;

  if (!inner) {
    cov_1bxgdyusb8.b[8][0]++;
    cov_1bxgdyusb8.s[29]++;
    inner = document.createElement('div');
    cov_1bxgdyusb8.s[30]++;
    inner.className = tooltipClass('inner');
    cov_1bxgdyusb8.s[31]++;
    div.appendChild(inner);
  } else {
    cov_1bxgdyusb8.b[8][1]++;
  }

  cov_1bxgdyusb8.s[32]++;
  currentId = id;
  cov_1bxgdyusb8.s[33]++;
  div.style.cssText = 'display: none';
  cov_1bxgdyusb8.s[34]++;
  Object.keys(style).forEach(function (k) {
    cov_1bxgdyusb8.f[4]++;
    cov_1bxgdyusb8.s[35]++;
    div.style[k] = transStyle(style[k]);
  });
  var className = (cov_1bxgdyusb8.s[36]++, tooltipClass('_', 'in', position, (cov_1bxgdyusb8.b[9][0]++, animation) && (cov_1bxgdyusb8.b[9][1]++, 'animation'))); // fix safari

  cov_1bxgdyusb8.s[37]++;
  timer = setTimeout(function () {
    cov_1bxgdyusb8.f[5]++;
    cov_1bxgdyusb8.s[38]++;
    div.style.display = 'block';
    cov_1bxgdyusb8.s[39]++;
    div.className = classnames(className, cn);
  }, 0);
  cov_1bxgdyusb8.s[40]++;
  ReactDOM.render(tip, inner);
  cov_1bxgdyusb8.s[41]++;
  inner.setAttribute('style', '');
  cov_1bxgdyusb8.s[42]++;

  if (innerStyle) {
    cov_1bxgdyusb8.b[10][0]++;
    cov_1bxgdyusb8.s[43]++;
    Object.keys(innerStyle).forEach(function (k) {
      cov_1bxgdyusb8.f[6]++;
      cov_1bxgdyusb8.s[44]++;
      inner.style[k] = transStyle(innerStyle[k]);
    });
  } else {
    cov_1bxgdyusb8.b[10][1]++;
  }

  cov_1bxgdyusb8.s[45]++;

  if (trigger === 'click') {
    cov_1bxgdyusb8.b[11][0]++;
    cov_1bxgdyusb8.s[46]++;
    document.addEventListener('click', clickaway);
  } else {
    cov_1bxgdyusb8.b[11][1]++;
  }
};
cov_1bxgdyusb8.s[47]++;
export var move = function move(id, pos) {
  cov_1bxgdyusb8.f[7]++;
  cov_1bxgdyusb8.s[48]++;

  if ((cov_1bxgdyusb8.b[13][0]++, id === currentId) && (cov_1bxgdyusb8.b[13][1]++, div)) {
    cov_1bxgdyusb8.b[12][0]++;
    cov_1bxgdyusb8.s[49]++;
    // eslint-disable-next-line no-return-assign
    Object.keys(pos).map(function (key) {
      cov_1bxgdyusb8.f[8]++;
      cov_1bxgdyusb8.s[50]++;
      return div.style[key] = transStyle(pos[key]);
    });
  } else {
    cov_1bxgdyusb8.b[12][1]++;
  }
};
cov_1bxgdyusb8.s[51]++;
export var isCurrent = function isCurrent(id) {
  cov_1bxgdyusb8.f[9]++;
  cov_1bxgdyusb8.s[52]++;
  return id === currentId;
};